import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MultiSelectV2 from '../MultiSelectV2';

const DateTypeSelectV2 = ({ onSelect, value, label, disabled, limitTags = 3 }) => {
  const handler = (newValue) => {
    let result = null;
    if (newValue) {
      result = newValue.map((v) => v.value);
    }
    onSelect(result);
  };

  const [options] = useState([
    { value: 'DATA_CRIACAO', label: 'Data Criação' },
    { value: 'DATA_DIGITACAO', label: 'Data Digitação' },
    { value: 'DATA_EXECUTADA_GDIS', label: 'Data Executada GDIS' },
    { value: 'DATA_INSPECAO', label: 'Data Inspeção' },
    { value: 'DATA_VENCIMENTO', label: 'Data Vencimento' },
  ]);

  return (
    <MultiSelectV2
      label={label}
      onChange={(newValue) => handler(newValue)}
      defaultValue={options && value ? options.filter((o) => value.indexOf(o.value) > -1) : []}
      options={options}
      disabled={disabled}
      limitTags={limitTags}
    />
  );
};

DateTypeSelectV2.propTypes = {
  value: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  limitTags: PropTypes.number,
};

DateTypeSelectV2.defaultProps = {
  value: null,
  label: undefined,
  disabled: false,
  limitTags: 3,
};

export default DateTypeSelectV2;
